import clsx from 'clsx';
import React from 'react';

import { PrimaryButton } from '@components/Button/variants';
import IconQuote from '@components/Images/Rebranding/IconQuote';
import LazyImgixImage from '@components/LazyImgixImage';
import useEventTracking from '@hooks/useEventTracking';
import { subscribe_path } from '@routes';
import { ClickTarget, click } from '@tracking';
import { getImgixSrc } from '@utils/images';

import { OFFER_PARAM } from '.';

const SUBSCRIBE = 'Subscribe';
interface PartnerProps {
  isSubscriber: boolean;
}

const PARTNERS_LOGO = [
  {
    name: 'Sequoia',
    path: 'landing_pages/financial_coverages/sequoia.png?auto=compress,format',
    width: 152,
  },
  {
    name: 'Goldman Sachs',
    path: 'landing_pages/financial_coverages/goldman_sachs.png?auto=compress,format',
    width: 77,
  },
  {
    name: 'General Atlantic',
    path: 'landing_pages/financial_coverages/general_atlantic.png?auto=compress,format',
    width: 144,
  },
  {
    name: 'Point 72',
    path: 'landing_pages/financial_coverages/point_72.png?auto=compress,format',
    width: 140,
  },
];

const OurPartner = ({ isSubscriber }: PartnerProps) => {
  const { trackEvent } = useEventTracking();
  return (
    <div className="py-64 md:mb-64 lg:mb-80">
      <aside className="mx-auto mb-48 flex w-full flex-wrap items-center justify-center gap-48 sm:justify-start md:w-auto lg:mx-auto  lg:flex-nowrap ">
        <h5 className="m-0 font-suisse-intl-mono text-overline-lg ">Where our subscribers work</h5>
        <div className="flex flex-wrap items-center justify-center gap-40 sm:justify-start  sm:gap-96 lg:gap-40">
          {PARTNERS_LOGO.map((logo) => (
            <LazyImgixImage
              key={logo.path}
              src={getImgixSrc({
                path: logo.path,
                isEnvDependent: false,
              })}
              sizes={`${logo.width}px`}
              alt={logo.name}
              className={clsx('flex min-w-[calc(50%-1rem)] flex-1')}
            />
          ))}
        </div>
      </aside>
      <div className="flex flex-wrap items-start justify-start gap-16 md:justify-center">
        <IconQuote className="w-36 text-primary-magenta" />
        <div className="max-w-[650px]">
          <p className="body-lg my-0 font-suisse-intl font-medium">
            The Information is one of the few trusted sources of tech news that I reference on a
            daily basis, sometimes even sourcing opportunities based on your team’s reporting. I
            know I speak on behalf of my firm when I say: all of us read The Information as the most
            reliable source of new venture news, development from other investors and incumbents and
            tech policy.
          </p>
          <div className="mt-16 font-suisse-screen text-byline-md text-grayscale-gray">
            <strong>Vinod Khosla</strong> | Founder, Khosla Ventures
          </div>
        </div>
      </div>
      {!isSubscriber && (
        <div className="flex justify-center">
          <PrimaryButton
            className="mt-32 !w-[340px] px-36 py-12"
            as="link"
            href={subscribe_path({ offer: OFFER_PARAM })}
            onClickCapture={() =>
              trackEvent(click({ clickTarget: ClickTarget.Subscribe, clickText: SUBSCRIBE }))
            }
          >
            {SUBSCRIBE}
          </PrimaryButton>
        </div>
      )}
    </div>
  );
};

export default OurPartner;
